import { useEffect, useState } from "react";
import { API } from "../lib/api";

export const DEFAULT_PRICING = {
  promoter_yearly: { amount: 49.99, interval: "year" },
  promoter_monthly: { amount: 14.99, interval: "month" },
  venue_yearly: { amount: 99, interval: "year" },
  venue_monthly: { amount: 29.99, interval: "month" },
  venue_extra_yearly: { amount: 35, interval: "year" },
  venue_extra_monthly: { amount: 12.99, interval: "month" },
};

export function formatPlanPrice(plan) {
  const amount = plan?.amount ?? 0;
  return `$${Number.isInteger(amount) ? amount.toFixed(0) : amount.toFixed(2)}`;
}

export function intervalLabel(plan) {
  return plan?.interval === "month" ? "month" : "year";
}

export function yearlySavings(monthlyPlan, yearlyPlan) {
  const save = Math.round((monthlyPlan?.amount ?? 0) * 12 - (yearlyPlan?.amount ?? 0));
  return save > 0 ? `save $${save}` : null;
}

export function BillingToggle({ value, onChange, testid, savings }) {
  return (
    <div className="flex gap-1 rounded-full border border-white/10 bg-black/50 p-0.5" data-testid={testid}>
      {["monthly", "yearly"].map((opt) => (
        <button key={opt} type="button" data-testid={`${testid}-${opt}`} onClick={() => onChange(opt)}
          className={`rounded-full px-3 py-1 text-[10px] font-black uppercase tracking-wider transition-colors duration-200 ${value === opt ? "bg-neon-gold text-black" : "text-zinc-500 hover:text-white"}`}>
          {opt}{opt === "yearly" && savings ? ` · ${savings}` : ""}
        </button>
      ))}
    </div>
  );
}

export function usePricing(city) {
  const [pricing, setPricing] = useState(DEFAULT_PRICING);
  useEffect(() => {
    const query = city ? `?city=${encodeURIComponent(city)}` : "";
    API.get(`/payments/pricing${query}`).then((r) => setPricing({ ...DEFAULT_PRICING, ...r.data })).catch(() => {});
  }, [city]);
  return pricing;
}
